// extracted by mini-css-extract-plugin
export default {"container":"SubmenuGroup_container__ChjGQ","visible":"SubmenuGroup_visible__fvAoS","delimiter":"SubmenuGroup_delimiter__t6Srv"};